"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CountBarStyles_1 = require("../../style/CountBarStyles");
var CountBar = /** @class */ (function (_super) {
    __extends(CountBar, _super);
    function CountBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CountBar.prototype.getWidth = function () {
        if (this.props.maxValue && this.props.currentValue) {
            return (100 * (this.props.currentValue / this.props.maxValue)) + '%';
        }
        return 0;
    };
    CountBar.prototype.render = function () {
        var barSizeStyle = {
            maxWidth: this.props.maxWidth,
            width: this.props.maxWidth,
            height: this.props.height,
            minWidth: this.props.currentValue && this.props.currentValue > 0 ? 2 : 0
        };
        return (React.createElement("div", { className: this.props.colorPaletteName && CountBarStyles_1.colorPalettes[this.props.colorPaletteName] },
            React.createElement("div", { className: this.props.shouldAnimateBarWidth ? CountBarStyles_1.animatedBaseBarClass : CountBarStyles_1.baseBarClass, style: barSizeStyle },
                React.createElement("div", { className: this.props.shouldAnimateBarWidth ? CountBarStyles_1.animatedFilteredBarClass : CountBarStyles_1.filteredBarClass, style: __assign({}, barSizeStyle, { width: this.getWidth() }) }),
                this.props.label ? React.createElement(CountBarStyles_1.BarLabel, { style: { lineHeight: this.props.height + 2 + "px" } }, this.props.label) : null)));
    };
    return CountBar;
}(React.Component));
exports.CountBar = CountBar;
//# sourceMappingURL=CountBar.js.map